import React from "react";
import MainAppGenericModal from "../../../../atoms/Modals/GenericModal";
import MainInput from "../../../../atoms/Forms/MainInput";

import styles from "./MainApp.organisms.Category.Modals.EditCategoryModal.module.scss";
import i18n from "i18n";

export class EditCategoryModal extends React.Component {
  render() {
    const {
      open,
      handleClose,
      category,
      handleChange
    } = this.props;

    const content = (<div className={styles["edit-category-modal-wrapper"]}>
      <i className={`${styles["product-modal-wrapper-close"]} icon-iconos_close2`} onClick={this.props.cancel}></i>

      <div className={styles["edit-category-modal-title"]}>{i18n.t("edit.category")}</div>
      <div className={styles["edit-category-modal-input"]}>
        <form onSubmit={this.props.confirm}>
          <MainInput value={category ? category.name : null} maxLength={50}
            handleChange={handleChange}>
          </MainInput>
        </form>
      </div>
      <div className={styles["edit-category-modal-buttons"]}>
        <div className={styles["edit-category-modal-button"]} onClick={this.props.cancel} data-automation-id="cancel">{i18n.t("cancel").toUpperCase()}</div>
        <div className={styles["edit-category-modal-button"]} onClick={this.props.confirm} data-automation-id="confirm">{i18n.t("save").toUpperCase()}</div>
      </div>
    </div>)
    return (
      <div className={styles["edit-category-modal-container"]}>
          <MainAppGenericModal open={open} content={content} handleClose={handleClose}></MainAppGenericModal>
      </div>
    );
  }
}

EditCategoryModal.propTypes = {
};

export default EditCategoryModal;